import { Component } from "@angular/core";
import { AuthService } from "src/app/services/auth/auth.service";
import { StyleService } from "src/app/services/style/style.service";

@Component({
    selector: "app-register-complete",
    templateUrl: "./register-complete.component.html",
    styleUrls: [ "./register-complete.component.scss" ]
})
export class RegisterCompleteComponent {
    protected readonly brandName: string;
    protected readonly brandImage: string;

    public constructor(authService: AuthService, styleService: StyleService) {
        this.brandName = authService.getTenantName();
        this.brandImage = styleService.getLogoUrl();
    }
}
